import { PORTFOLIO_METRIC_REASON_LABELS, PORTFOLIO_METRIC_QUALITY_OBJ, type PortfolioMetricAvailability } from "@signals/shared";

/** Show the server's assessment without deriving availability from another metric. */
export function PortfolioMetricStatus({ availability }: { availability?: PortfolioMetricAvailability | undefined }) {
  if (!availability || availability.available && availability.quality === PORTFOLIO_METRIC_QUALITY_OBJ.CONFIRMED) return null;
  const reasons = [...new Set(availability.reasons.map((reason) => PORTFOLIO_METRIC_REASON_LABELS[reason.code]?.["ru-RU"] ?? reason.code))];
  return <p className="mt-1 text-xs text-amber-800 dark:text-amber-300">
    {availability.available ? "Оценка" : "Недостаточно данных"}{reasons.length > 0 ? `: ${reasons.join("; ")}` : ""}
  </p>;
}
